import { hot } from 'react-hot-loader/root';

import Root from './Root';

export default hot(Root);
